import { useSeo } from "../components/site/Layout";
import { PageHero, Section, CtaBand } from "../components/site/blocks";
import { ZoneMap } from "../components/site/ZoneMap";
import { IDF_DEPTS, NEIGHBOR_REGIONS } from "../data/site";

export default function Zone() {
  useSeo("Zone d'intervention : Île-de-France et régions limitrophes", "Habitalys intervient dans les 8 départements d'Île-de-France (75, 77, 78, 91, 92, 93, 94, 95) et, sur demande, dans les régions limitrophes.");
  return (
    <>
      <PageHero eyebrow="Zone d'intervention" title="Au plus près de vous" intro="Siège à Fresnes (94). Intervention dans toute l'Île-de-France, et sur demande dans les régions voisines." />
      <Section testid="zone-page-map" className="!pt-4"><ZoneMap /></Section>
      <Section tone="mist" testid="zone-lists">
        <div className="grid lg:grid-cols-2 gap-8">
          <div data-testid="zone-idf">
            <p className="eyebrow">Intervention</p>
            <ul className="mt-4 grid grid-cols-2 gap-2">
              {IDF_DEPTS.map(([n, name]) => <li key={n} data-testid={`zone-dept-${n}`} className="flex items-center gap-3 rounded-2xl bg-white border border-brand/15 px-4 py-3"><span className="font-display text-brand-ink w-7">{n}</span><span className="text-navy text-[15px]">{name}</span></li>)}
            </ul>
          </div>
          <div data-testid="zone-regions">
            <p className="eyebrow">Sur demande</p>
            <ul className="mt-4 flex flex-wrap gap-2">
              {NEIGHBOR_REGIONS.map((r) => <li key={r} className="rounded-full bg-white border border-brand/15 px-4 py-2.5 text-navy text-[15px]">{r}</li>)}
            </ul>
          </div>
        </div>
      </Section>
      <CtaBand />
    </>
  );
}
